var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '8px',
'height': '12px',
'viewBox': '0 0 8 12',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45 (43475) - http://www.bohemiancoding.com/sketch --> <title>Material/Icons black/chevron right</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"SUPER-ADMIN\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"1.0-Landing-Page--On-board-only\" transform=\"translate(-1080.000000, -259.000000)\" fill=\"#000000\"> <g id=\"Onboarding---Card\" transform=\"translate(60.000000, 116.000000)\"> <g id=\"Entities-registered\" transform=\"translate(666.000000, 108.000000)\"> <g id=\"Material/Icons-black/chevron-right\" transform=\"translate(346.000000, 29.000000)\"> <polygon id=\"Shape\" points=\"8.59997559 7.4 9.99997559 6 15.9999756 12 9.99997559 18 8.59997559 16.6 13.1999756 12\"></polygon> </g> </g> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/chevron-right.svg